export const LIST = "LUCKY_SPIN_SETTING_LIST";
export const DETAILS = "LUCKY_SPIN_SETTING_DETAILS";
export const UPDATE = "LUCKY_SPIN_SETTING_UPDATE";
export const STORE = "LUCKY_SPIN_SETTING_STORE";
export const UPDATE_STATUS = "LUCKY_SPIN_SETTING_UPDATE_STATUS";